import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBulb = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 22,
	viewBox: "0 0 23 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		opacity: .8,
		d: "M20.5 10L19.875 8.625L18.5 8L19.875 7.375L20.5 6L21.125 7.375L22.5 8L21.125 8.625L20.5 10ZM17.5 6L16.55 3.95L14.5 3L16.55 2.05L17.5 0L18.45 2.05L20.5 3L18.45 3.95L17.5 6ZM7.5 22C6.95 22 6.47917 21.8042 6.0875 21.4125C5.69583 21.0208 5.5 20.55 5.5 20H9.5C9.5 20.55 9.30417 21.0208 8.9125 21.4125C8.52083 21.8042 8.05 22 7.5 22ZM3.5 19V17H11.5V19H3.5ZM3.75 16C2.6 15.3167 1.6875 14.4 1.0125 13.25C0.3375 12.1 0 10.85 0 9.5C0 7.41667 0.729167 5.64583 2.1875 4.1875C3.64583 2.72917 5.41667 2 7.5 2C9.58333 2 11.3542 2.72917 12.8125 4.1875C14.2708 5.64583 15 7.41667 15 9.5C15 10.85 14.6625 12.1 13.9875 13.25C13.3125 14.4 12.4 15.3167 11.25 16H3.75ZM4.35 14H10.65C11.4 13.4667 11.9792 12.8083 12.3875 12.025C12.7958 11.2417 13 10.4 13 9.5C13 7.96667 12.4667 6.66667 11.4 5.6C10.3333 4.53333 9.03333 4 7.5 4C5.96667 4 4.66667 4.53333 3.6 5.6C2.53333 6.66667 2 7.96667 2 9.5C2 10.4 2.20417 11.2417 2.6125 12.025C3.02083 12.8083 3.6 13.4667 4.35 14Z",
		fill: "#3E2BB7"
	})
});
export default SvgBulb;
